import React from 'react';
import { AdminBook, getJourneyType } from '../types';

interface BookInfoSectionProps {
  book: AdminBook;
}

const BookInfoSection: React.FC<BookInfoSectionProps> = ({ book }) => {
  const infoItems = [
    { label: 'Title', value: book.title },
    { label: 'User', value: book.user?.email || book.user?.phoneNumber || 'Unknown' },
    { label: 'Phone Number', value: book.user?.phoneNumber || 'Not on file' },
    { label: 'User ID', value: book.user?._id || 'No linked user' },
    { label: 'Language', value: book.language },
    { label: 'Trim Size', value: book.bookSize || 'Not set' },
    { label: 'Binding', value: book.bindingType || 'Not set' },
    { label: 'Paper Type', value: book.paperType || 'Not set' },
    { label: 'Interior Color', value: book.interiorColor || 'Not set' },
    { label: 'Cover Lamination', value: book.coverLamination || 'Not set' },
    { label: 'Page Count', value: book.pageCount ? `${book.pageCount} pages` : 'Generating...' },
    { label: 'ISBN', value: book.isbn || (book.hasISBN ? 'Opted — pending assignment' : 'Not opted') },
    { label: 'Journey Type', value: getJourneyType(book) },
    ...(book.addons?.coverDesign ? [{ label: 'Cover Design', value: book.addons.coverDesignType ? `Yes · ${book.addons.coverDesignType.charAt(0).toUpperCase() + book.addons.coverDesignType.slice(1)}` : 'Yes' }] : []),
  ];

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Book Info</h2>
      </div>
      <div className="px-6 py-4 grid grid-cols-2 gap-4">
        {infoItems.map((item) => (
          <div key={item.label}>
            <dt className="text-sm font-medium text-gray-500">{item.label}</dt>
            <dd className="mt-1 text-sm text-gray-900">{item.value}</dd>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookInfoSection;
